export default {
  jobs: [],
  jobItems: [],
  selectedJob: {}
}
